import { render, staticRenderFns } from "./WebhookHeadersConfig.vue?vue&type=template&id=4425788d"
import script from "./WebhookHeadersConfig.vue?vue&type=script&lang=js"
export * from "./WebhookHeadersConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports